import { h } from 'preact';
import SVGWrapper from '../../SvgWrapper';

function NextIcon({ height = 60, width = 60, color = 'white', ...props }) {
  return (
    <SVGWrapper
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      style={props?.style || {}}
    >
      <clipPath id="clip_next_icon"><path d="m0 0h24v24h-24z" /></clipPath>
      <g clipPath="url(#clip_next_icon)" fill={color}>
        <path d="m19.275 6.00007v12.00003h-1.35v-12.00003z" />
        <path d="m4.80005 6.7093c0-.61057.6926-.96753 1.19395-.61904 1.20265.83596 3.08262 2.11389 4.5318 2.96681 1.4315.84256 3.4176 1.84563 4.7692 2.50943.5813.2854.5647 1.1333-.0269 1.3966-1.3502.6008-3.3184 1.5038-4.7423 2.2725-1.45653.7862-3.35277 1.9783-4.55509 2.7518-.50321.3237-1.17066-.0355-1.17066-.6339z" />
      </g>
    </SVGWrapper>
  );
}

export default NextIcon;
